module.exports = __webpack_public_path__ + "51b6bc90ed1b495b18a0efc4b0398ee2.png";